module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "metrics"
  }, [_c('button', {
    on: {
      "click": _vm.clearLoadEvent
    }
  }, [_vm._v("Очистить")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.copyLoadEvent
    }
  }, [_vm._v("Скопировать в буфер")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openFullDebug
    }
  }, [_vm._v("Открыть окно с графиками")]), _vm._v(" "), _c('canvas', {
    ref: "loadEvent",
    staticStyle: {
      "border": "1px solid #000000"
    },
    attrs: {
      "id": "loadEvent",
      "width": "640",
      "height": "15"
    }
  }), _vm._v(" "), _c('canvas', {
    ref: "bitrateTimerange",
    staticStyle: {
      "border": "1px solid #000000"
    },
    attrs: {
      "id": "bitrateTimerange",
      "width": "640",
      "height": "100"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c237a4bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Debug/DebugMetrics.vue
// module id = 99
// module chunks = 0